import styled from 'react-emotion'
import { space, themeGet as th } from 'styled-system'

const AddContact = ({ className, onClick }) => {
  return (
    <div className={className} onClick={onClick}>
      Add contact
    </div>
  )
}

export default styled(AddContact)`
  color: ${th('colors.gray')};
  cursor: pointer;

  ${space};
`
